import { useEffect } from "react";
import { bootstrapApp, selectBootstrapPhase } from "@/src/store/features/bootstrapSlice";
import { useAppDispatch, useAppSelector } from "@/src/store/hooks";
export const useBootstrap = () => {
  const dispatch = useAppDispatch();
  const phase = useAppSelector(selectBootstrapPhase);
  useEffect(() => {
    // Only auto-run bootstrap once on first load.
    // If bootstrap fails, leave the app in "error" until the user retries
    // (otherwise a failing backend/CORS setup causes an infinite request loop).
    if (phase === "idle") {
      void dispatch(bootstrapApp());
    }
  }, [phase, dispatch]);
  return phase;
};